import api from './axios';

export interface TokenUsageItem {
  api_key_id: string;
  total_tokens: number;
  max_tokens: number;
}

export interface SubscriptionInfo {
  name: string;
  price: number;
  frequency: string;
  startDate: string;
  endDate: string;
}

export interface UsageData {
  organization_id: string;
  total_users: number | null;
  max_users: number | null;
  total_workspaces: number | null;
  max_workspaces: number | null;
  total_agents: number | null;
  max_agents: number | null;
  total_workflows: number | null;
  max_workflows: number | null;
  total_document_storage_size_mb: number | null;
  max_storage_size_mb: number | null;
  token_usage_items: TokenUsageItem[];
  subscriptionInfo?: SubscriptionInfo;
}

export interface TokenUsageHistoryItem {
  date: string;
  tokens: number;
  requests: number;
}

export interface TokenUsageHistoryData {
  items: TokenUsageHistoryItem[];
  total_requests: number;
  total_tokens: number;
}

export interface UsageOverviewParams {
  start_date: string;
  end_date: string;
}

export interface TokenUsageHistoryParams {
  start_date: string;
  end_date: string;
  api_key_id: string;
}

// Usage API
export const usageApi = {
  // Get usage overview data for the organization
  getUsageOverview: async (params: UsageOverviewParams): Promise<UsageData> => {
    const response = await api.get('/subscriptions/usage-overview', {
      params
    });
    return response.data;
  },

  // Get token usage history for a specific API key
  getTokenUsageHistory: async (params: TokenUsageHistoryParams): Promise<TokenUsageHistoryData> => {
    const response = await api.get('/subscriptions/token-usage', {
      params
    });
    return response.data;
  },
};
